import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/shared/api';
import { PENDING } from './channelPriceText';

export function useChannelPriceModifiers(propertyId?: string) {
  const api = useApi();
  const queryClient = useQueryClient();
  const queryKey = ['channel-price-modifiers', propertyId] as const;
  const query = useQuery({
    queryKey,
    queryFn: () => api.channelPriceModifiers.get(propertyId!),
    enabled: Boolean(propertyId),
    refetchInterval: (state) =>
      state.state.data?.some((item) => PENDING.includes(item.operationStatus ?? ''))
        ? 1_500
        : false,
    refetchIntervalInBackground: false,
  });
  const preview = useMutation({
    mutationFn: ({
      connectionStateId,
      increasePercent,
      concurrency,
    }: {
      connectionStateId: string;
      increasePercent: number | null;
      concurrency: number;
    }) =>
      api.channelPriceModifiers.preview(propertyId!, connectionStateId, {
        increasePercent,
        concurrency,
      }),
    retry: false,
    networkMode: 'always',
    // Meist ist der Stand veraltet (`channel_modifier_stale`); der nächste Versuch braucht den neuen.
    onError: () => queryClient.invalidateQueries({ queryKey }),
  });
  const update = useMutation({
    mutationFn: ({
      connectionStateId,
      increasePercent,
      concurrency,
    }: {
      connectionStateId: string;
      increasePercent: number | null;
      concurrency: number;
    }) =>
      api.channelPriceModifiers.update(propertyId!, connectionStateId, {
        increasePercent,
        concurrency,
      }),
    retry: false,
    // Ohne Antwort ist offen, ob Channex beauftragt wurde – danach zählt der Stand des Servers.
    networkMode: 'always',
    onSettled: () => queryClient.invalidateQueries({ queryKey }),
  });
  return { query, preview, update };
}
